import { createAction } from "redux-act";

export const setCash = createAction("set money cash value");

export const currentCashSet = (increment) => async (dispatch) => {
  dispatch(setCash({ increment }));
};
